import { memo, useCallback, useMemo, useState } from 'react';
import { useGetWinners } from 'react-easyrocket';
import Marquee from 'react-fast-marquee';
import RecentWinnerItem from './components/RecentWinnerItem';
import { SkeletonOfAnySize } from 'src/components/Skeletons';

const _RecentWinners = () => {
  const { allWinners, isFetching, isFetched } = useGetWinners();
  const [isPlayMarquee, togglePlayMarquee] = useState(true);

  const handlePlayMarquee = useCallback(() => {
    togglePlayMarquee(false);
  }, []);
  const handleStopMarquee = useCallback(() => {
    togglePlayMarquee(true);
  }, []);

  const RecentWinnersElements = useMemo(() => {
    if (isFetching) {
      return Array.from({ length: 10 }).map((_, index) => (
        <SkeletonOfAnySize key={index} className="w-[250px] h-[110px] rounded-[5px] mx-2" />
      ));
    }

    if (!allWinners.length && !isFetching) {
      return null;
    }

    return allWinners.map((winner, index) => (
      <RecentWinnerItem
        key={index}
        winner={winner}
        handlePlayMarquee={handlePlayMarquee}
        handleStopMarquee={handleStopMarquee}
      />
    ));
  }, [isFetching, allWinners]);

  return (
    <>
      {(isFetched && allWinners.length > 0) || isFetching ? (
        <Marquee
          direction="left"
          speed={40}
          play={isPlayMarquee}
          className="py-5 768:py-10 flex items-center">
          {RecentWinnersElements}
        </Marquee>
      ) : null}
    </>
  );
};

export const RecentWinners = memo(_RecentWinners);
